
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import vuedraggable from 'vuedraggable'
import Sortable from 'sortablejs'
@Component({
    components: { vuedraggable }
})


export default class PacketBaseCourse extends Vue {
    @Prop() dialogPacketBasecourse: boolean
    @Prop() title: string
    @Prop() header: any
    @Prop() tableData: any
    @Prop() listDetailId: string
    @Prop() listDetailType: string  // theme points
    @Prop() name: string
    @Prop() defaultCourseId: string

    dialogPacketBasecourseAddUpdate: boolean = false
    oldList: number[] = []
    newList: number[] = []
    sortable: Sortable | null = null
    list: any = []
    addPacketBaseCourse: any = {}
    is_enabled: boolean = true
    courseTitleList: any = [] // 基础课程名list
    selectBaseCourseStudentCount: string = ""
    perTimes: any = []
    selectBaseCourseID: number = null
    option_type: string = null
    row_id: number = null
    selectBaseCourseName: string = null

    multipleSelection: array = []


    @Watch('dialogPacketBasecourse')
    getDialog(newVal, oldVal) {
        console.log(newVal, 'newval')
        this.resetAddOrUpdata()
        if (newVal) {
            this.list = this.tableData
            this.oldList = this.list.map((v) => v.id)
            this.newList = this.oldList.slice()
            this.$nextTick(() => {
                this.setSort()
            })
        }
    }

    close() {
        this.$emit('close', { type: false, data: [] })
    }

    setSort() {
        const el = (this.$refs.draggableTable as Vue).$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0] as HTMLElement

        this.sortable = Sortable.create(el, {
            ghostClass: 'sortable-ghost', // Class name for the drop placeholder
            onEnd: evt => {
                if (typeof (evt.oldIndex) !== 'undefined' && typeof (evt.newIndex) !== 'undefined') {
                    const targetRow = this.list.splice(evt.oldIndex, 1)[0]
                    this.list.splice(evt.newIndex, 0, targetRow)

                    // for show the changes, you can delete in you code
                    const tempIndex = this.newList.splice(evt.oldIndex, 1)[0]
                    this.newList.splice(evt.newIndex, 0, tempIndex)
                }
            }
        })
    }

    toggleSelection(rows) {
        if (rows) {
            rows.forEach(row => {
                console.log(row, 'row')
                this.$refs.draggableTable.toggleRowSelection(row);
            });
        } else {
            this.$refs.draggableTable.clearSelection();
        }
    }
    handleSelectionChange(val) {
        console.log(val, 'val')
        this.multipleSelection = val;
    }

    async getCourseList() {
        // 获取course list
        const res: any = await CourseModule.getBaseCourseAll()
        if (res.code === 200) {
            this.courseTitleList = res.data
            for (var i = 0; i < this.courseTitleList.length; i++) {
                this.courseTitleList[i]['list_index'] = i + 1
            }
        }
    }

    async addPacketBaseCourseClick() {
        this.dialogPacketBasecourseAddUpdate = true
        this.option_type = 'add'
        this.perTimes = []
        this.selectBaseCourseStudentCount = null
        this.selectBaseCourseID = null
        this.is_enabled = true
        this.row_id = null
        this.selectBaseCourseName = null
        this.getCourseList()
    }

    async deletePacketBaseCourseClick() {
        console.log(this.multipleSelection, 'selectection')
        const selectIds = this.multipleSelection.map((v) => v.id)
        // 删除数据
        const res: any = await CourseModule.deletePacketBaseCourse({ '_id': selectIds, 'packet_id': this.listDetailId })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.list = res.data
        }
    }
    async setSorted() {
        console.log(this.newList, 'newList')
        const res: any = await CourseModule.updatePacketBaseCourseSort({ packet_id: this.listDetailId, list: this.newList })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '保存成功!'
            })
        }
    }

    closeAddUpdata() {
        this.dialogPacketBasecourseAddUpdate = false
    }

    changeBaseCourse(val) {
        this.perTimes = []
        var student_count = 0
        var courseTitle = null
        // 绑定最大学员数据(生成对应个数输入框)
        for (let i = 0; i < this.courseTitleList.length; i++) {
            if (this.courseTitleList[i].id == val) {
                courseTitle = this.courseTitleList[i]
            }
        }
        var count = courseTitle.student_count
        var arr = new Array(count)
        for (let i = 0; i < arr.length; i++) {
            const item = {
                "id": i,
                "label": `${i + 1}人/扣减课次`,
                "name": `time_${i + 1}`,
                [`time_${i + 1}`]: i + 1
            }
            this.perTimes.push(item)
        }
        this.selectBaseCourseStudentCount = count
    }
    selectBaseCourse() {
        console.log("selectBaseCourse")
    }
    async doAddOrUpdate() {
        if (this.option_type == 'add') {
            this.addDPacketBaseCourse()
        } else {
            this.updatePacketBaseCourse()
        }
        this.resetAddOrUpdata()
        // 返回上一个dialog刷新数据
        this.dialogPacketBasecourseAddUpdate = false
    }

    makeData() {
        // 获取settings
        let settings = []
        console.log(this.perTimes)
        for (let i = 0; i < this.perTimes.length; i++) {
            // [{"1": 1}, {"2": 0.8}]
            const perTime = this.perTimes[i]
            const person = perTime['time_' + (i + 1)]
            let ptime = 0
            console.log(perTime, 'perTime')
            ptime = perTime.name
            const item = {
                [person]: ptime
            }
            settings.push(item)
        }
        // 组织form数据提交
        const data = {
            "is_enabled": this.is_enabled,
            "packet_id": this.listDetailId,
            "base_course_id": this.selectBaseCourseID,
            "settings": settings,
            "id": this.row_id
        }
        return data
    }

    async addDPacketBaseCourse() {
        /**
         * 新增套餐基础课程设置
         * */
        const data = this.makeData()

        // 创建数据
        const res: any = await CourseModule.PacketBaseCourse(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '添加成功!'
            })
            this.list = res.data
        } else {
            this.$message({
                type: 'error',
                message: res.message
            })
        }
        console.log("addDPacketBaseCourse")
    }

    async updatePacketBaseCourse() {
        console.log("updatePacketBaseCourse")
        const data = this.makeData()
        console.log(data)

        // 修改数据
        const res: any = await CourseModule.updatePacketBaseCourse(data)
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '修改成功!'
            })
            this.list = res.data
        }
        this.row_id = null
    }

    async goUpdatePacketBaseCourse(row) {
        /**
         * 更新套餐基础课程设置
         * */
        console.log("updatePacketBaseCourse")
        console.log(row)
        this.is_enabled = row.is_enabled === 1 ? true : false
        this.selectBaseCourseID = row.base_course_id
        this.selectBaseCourseStudentCount = row.student_count
        this.selectBaseCourseName = row.name
        this.row_id = row.id
        this.perTimes = []
        this.getCourseList()

        let settings_length = row.settings.length
        const res = await CourseModule.baseCourseDetail({ base_course_id: row.base_course_id })
        if (res.code == 200) {
            if (res.data.student_count > settings_length) {
                const add_count = res.data.student_count - settings_length
                const new_array = Array(add_count)
                for (let i = 0; i < new_array.length; i++) {
                    settings_length = settings_length + 1
                    const key = "" + settings_length
                    const item = {
                        [key]: '0'
                    }
                    row.settings.push(item)
                }
            }
        }
        // this.perTimes = settings
        for (let i = 0; i < row.settings.length; i++) {
            const setting = row.settings[i]
            const time_name = `time_${i + 1}`
            const item = {
                "id": i,
                "label": `${i + 1}人/扣减课次`,
                "name": setting[`${i + 1}`],
                [time_name]: Object.keys(setting)[0]
            }
            console.log(item, 'item')
            this.perTimes.push(item)
        }
        this.dialogPacketBasecourseAddUpdate = true
        this.option_type = 'edit'
    }
    async deletePacketBaseCourse(row) {
        /**
         * 删除套餐基础课程设置
         * */
        console.log("deletePacketBaseCourse")
        console.log(row)

        // 删除数据
        const res: any = await CourseModule.deletePacketBaseCourse({ '_id': [row.id], 'packet_id': this.listDetailId })
        if (res.code === 200) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.list = res.data
        }
    }
    resetAddOrUpdata() {
        this.is_enabled = null
        this.selectBaseCourseID = null
        this.selectBaseCourseStudentCount = null
        this.perTimes = []
    }

    mounted() {

    }
}
